import FormSectionTitle from '../../../../elements/FormSectionTitle'
import withSpinning from '../../../../elements/HOC/withSpinning'
import InfoTooltip from '../../../../elements/InfoTooltip'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import React, { Fragment, useEffect, useState } from 'react'
import { Col, Form, Input, Radio, Row, Select } from 'antd'
import { get, isEmpty } from 'lodash'

import { compose } from 'recompose'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import EmployeesSelect from '../../../../elements/Select/Employee/EmployeesSelect'
import { EnquiriesSelect } from '../../../../components/Sales/Quotes/AddQuote/AddQuote'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import CustomSpin from '../../../../elements/CustomSpin'
import Authentication from '../../../../modules/Authentication'
import withSort from '../../../../elements/HOC/withSort'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'

const QCTypeSelect = compose(
  withSelectFetch({
    dropdown: 'controlDocs',
    name: 'docTypes',
    cache: false,
  }),
  withSort,
)(CustomSelect)

// const QCControlDocSelect = compose(
//   // Should be a DB select from controlDocs filter activity.code == "QAS" & docType.code == getfield type.code
//   withSelectFetch({
//     dropdown: 'controlDocs',
//     name: 'docTypes',
//     cache: false,
//   }),
//   withSort,
// )(CustomSelect)

const { TextArea } = Input

const auth = new Authentication()

function QCForm (props) {
  const { qc, enquiryID, isNew } = props
  const { getFieldDecorator } = props.form

  const { getFieldValue, setFieldsValue, resetFields } = props.form

  const [order, setOrder] = useState({})

  const [SalesOrderSelect] = useFetchSelectUrl(
    {
      name: 'salesOrder',
      url: `enquiries/${(getFieldValue('enquiry._id') || '').replace('activities/', '')}/salesOrder`,
      cache: false,
    },
    [getFieldValue('enquiry._id')],
    isEmpty(getFieldValue('enquiry._id')),
    Select,
    (enquiry) => ({
      ...enquiry,
      display: `${enquiry.code} - ${enquiry.title}`,
    }),
  )

  const { fetch, fetching, object: enquiry, setObject: setEnquiry } = useFetchObject(
    () => EnquiriesApi.read((getFieldValue('enquiry._id') || '').replace('activities/', '')),
    false,
    [getFieldValue('enquiry._id')],
    isEmpty(getFieldValue('enquiry._id')) || qc._id,
  )
  React.useEffect(() => {
    if (!isEmpty(enquiry) && !qc._id)
      setFieldsValue({
        title: enquiry.title,
        'company._id': get(enquiry, 'company._id'),
      })
  }, [enquiry._rev])

  const FileSelectCmp = compose(
    withUrlFetch({
      name: `${qc._id}_files`,
      url: `files/?folder=${qc._id}`,
      forceFetch: true,
      dontFetch: isEmpty(qc._id),
    }),
    withSpinning,
    withSort,
  )(CustomSelect)

  const codeSalesOrder = get(order, 'code', '').replace('-', '') // get code
  const codeName = 'QAS'
  const codeType = getFieldValue('qc.type.code')
  const codeControlledDoc = getFieldValue('qc.controlDoc.code') //last 2 digits of controlledDoc Code
  const codePartCode = getFieldValue('qc.partCode')
  const codeProductCode = getFieldValue('qc.productCode')

  const isCodeReady =
    !isEmpty(codeSalesOrder) &&
    !isEmpty(codePartCode) &&
    !isEmpty(codeName) &&
    !isEmpty(codeProductCode) &&
    !isEmpty(codeControlledDoc) &&
    !isEmpty(codeType)

  const isCodeEditable = isNew || qc.status === 'Draft'

  useEffect(() => {
    if (isCodeReady && isCodeEditable) {
      const subCode = [codeName, codeControlledDoc.split('-').pop(), codeType].join('')
      const code = [codeSalesOrder, subCode, codeProductCode, codePartCode].join('-') + '.00'
      setFieldsValue({ code })
    }
  }, [codeSalesOrder, codeName, codePartCode, codeType, codeProductCode, codeControlledDoc])

  const isSale = getFieldValue('budget.budgetType') === 'Sales'

  const [QCControlDocSelect] = useFetchSelectUrl(
    {
      name: 'controlled_document',
      forceFetch: true,
      url: `controlDocs?select=*&activity=${codeName}&docType=${codeType}`,
    },
    [codeType, codeName],
  )

  return (
    <Form>
      <CustomSpin spinning={fetching}>
        <Row>
          {isCodeReady && isCodeEditable && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="QC Code">
                {getFieldDecorator('code', {
                  initialValue: get(qc, 'code'),
                  rules: rules.input,
                })(<Input disabled={!isCodeEditable} style={{ width: '100%' }}/>)}
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Activity Type">
              {getFieldDecorator('budget.budgetType', {
                initialValue: get(qc, 'budget.budgetType') || 'Sales',
                /*? 'Sales'
                : 'Internal',*/
              })(
                <Radio.Group>
                  <Radio.Button value="Internal" disabled>
                    Internal
                  </Radio.Button>
                  <Radio.Button value="Sales">Sales</Radio.Button>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
        </Row>
        {isSale && (
          <Fragment>
            <FormSectionTitle title={'CLIENT DETAILS'}/>
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Enquiry">
                  {getFieldDecorator('enquiry._id', {
                    initialValue: get(qc, 'enquiry._id') || enquiryID,
                    rules: rules.select,
                  })(<EnquiriesSelect keyAtr={'_id'} valueAtr={'display'} placeholder={'Select an enquiry'}/>)}
                </Form.Item>
              </Col>
              {!!getFieldValue('enquiry._id') && (
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Sales Order">
                    {getFieldDecorator('order._id', {
                      initialValue: get(qc, 'order._id'),
                      rules: rules.select,
                    })(
                      <SalesOrderSelect
                        keyAtr={'_id'}
                        valueAtr={'display'}
                        placeholder={'Select an Sales Order'}
                        setSelected={setOrder}
                      />,
                    )}
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Fragment>
        )}
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Company">
              {getFieldDecorator('company._id', {
                initialValue: get(qc, 'company._id') || 'members/294426329241',
                rules: rules.select,
              })(<OrganisationsSelect/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Creator">
              {getFieldDecorator('creator._id', {
                initialValue: get(qc, 'creator._id') || auth.getMember()._id,
                rules: rules.select,
              })(
                <EmployeesSelect placeholder="Created By" keyAtr={'_id'} valueAtr={'name'} style={{ width: '100%' }}/>,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Approver">
              {getFieldDecorator('approval._id', {
                initialValue: get(qc, 'approval._id'),
                //rules: rules.select,
              })(
                <EmployeesSelect placeholder="Approved By" keyAtr={'_id'} valueAtr={'name'} style={{ width: '100%' }}/>,
              )}
            </Form.Item>
          </Col>
        </Row>

        <FormSectionTitle title={'DOCUMENT DETAILS'}/>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Doc Type">
              {getFieldDecorator('qc.type.code', {
                initialValue: get(qc, 'qc.type.code'),
                rules: rules.select,
              })(<QCTypeSelect keyAtr={'code'} valueAtr={'description'} style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Controlled Doc">
              {getFieldDecorator('qc.controlDoc.code', {
                initialValue: get(qc, 'qc.controlDoc.code'),
                rules: rules.select,
              })(<QCControlDocSelect keyAtr={'code'} valueAtr={'description'} style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Stock Code">
              {getFieldDecorator('qc.productCode', {
                initialValue: get(qc, 'qc.productCode'),
                rules: rules.input,
              })(<Input maxLength="3" style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Part Code">
              {getFieldDecorator('qc.partCode', {
                initialValue: get(qc, 'qc.partCode'),
                rules: rules.input,
              })(<Input maxLength="3" style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Doc Title">
              {getFieldDecorator('title', {
                initialValue: get(qc, 'title'),
                rules: rules.input,
              })(<Input style={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...defaultFormItemLayout}
              label={
                <InfoTooltip value={'File Selection'} title={'If empty; please upload files in documents tab.'}/>
              }>
              {getFieldDecorator('qcFile', {
                initialValue: get(qc, 'qcFile'),
              })(<FileSelectCmp keyAtr="_id" valueAtr="name" placeholder={'QC Document'}/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Description">
              {getFieldDecorator('description', {
                initialValue: get(qc, 'description'),
              })(<TextArea style={{ height: 100 }}/>)}
            </Form.Item>
          </Col>
        </Row>
      </CustomSpin>
    </Form>
  )
}

QCForm.propTypes = {}
QCForm.defaultProps = {}

export default Form.create()((QCForm))
